import types from './types';

export default (
  state = {
    isFetchingQuizCard: false,
    quizCard: null,
    quizCardError: "",

    isFetchingQuizSystem: false,
    quizSystem: null,
    quizSystemError: "",

    isFetchingQuizMain: false,
    quizMain: null,
    quizMainError: "",

    isUpdatingQuiz: false,
    updatedQuiz: null,
    updatedQuizError: "",

    isFetchingQuestions: false,
    questions: [],
    questionsError: "",

    isUpdatingLogo: false,
    updatedLogo: null,
    logoUpdateError: "",

    isFetchingAnswers: false,
    answers: [],
    answersError: "",
  }, action
) => {
  switch (action.type) {
    case types.GET_QUIZ_CARD_REQUEST:
      return {
        ...state,
        isFetchingQuizCard: action.isFetchingQuizCard
      };
    case types.GET_QUIZ_CARD_COMPLETED:
      return {
        ...state,
        isFetchingQuizCard: action.isFetchingQuizCard,
        quizCard: action.quizCard
      };
    case types.GET_QUIZ_CARD_ERROR:
      return {
        ...state,
        isFetchingQuizCard: action.isFetchingQuizCard,
        quizCardError: action.quizCardError
      };

    case types.GET_QUIZ_SYSTEM_INFO_REQUEST:
      return {
        ...state,
        isFetchingQuizSystem: action.isFetchingQuizSystem
      };
    case types.GET_QUIZ_SYSTEM_INFO_COMPLETED:
      return {
        ...state,
        isFetchingQuizSystem: action.isFetchingQuizSystem,
        quizSystem: action.quizSystem
      };
    case types.GET_QUIZ_SYSTEM_INFO_ERROR:
      return {
        ...state,
        isFetchingQuizSystem: action.isFetchingQuizSystem,
        quizSystemError: action.quizSystemError
      };

    case types.GET_QUIZ_MAIN_REQUEST:
      return {
        ...state,
        isFetchingQuizMain: action.isFetchingQuizMain
      };
    case types.GET_QUIZ_MAIN_COMPLETED:
      return {
        ...state,
        isFetchingQuizMain: action.isFetchingQuizMain,
        quizMain: action.quizMain
      };
    case types.GET_QUIZ_MAIN_ERROR:
      return {
        ...state,
        isFetchingQuizMain: action.isFetchingQuizMain,
        quizMainError: action.quizMainError
      };

    case types.UPDATE_QUIZ_MAIN_REQUEST:
      return {
        ...state,
        isUpdatingQuiz: action.isUpdatingQuiz
      };
    case types.UPDATE_QUIZ_MAIN_COMPLETED:
      return {
        ...state,
        isUpdatingQuiz: action.isUpdatingQuiz,
        updatedQuiz: action.updatedQuiz
      };
    case types.UPDATE_QUIZ_MAIN_ERROR:
      return {
        ...state,
        isUpdatingQuiz: action.isUpdatingQuiz,
        updatedQuizError: action.updatedQuizError
      };

    case types.GET_QUESTION_LIST_REQUEST:
      return {
        ...state,
        isFetchingQuestions: action.isFetchingQuestions
      };
    case types.GET_QUESTION_LIST_COMPLETED:
      return {
        ...state,
        isFetchingQuestions: action.isFetchingQuestions,
        questions: action.questions
      };
    case types.GET_QUESTION_LIST_ERROR:
      return {
        ...state,
        isFetchingQuestions: action.isFetchingQuestions,
        questionsError: action.questionsError
      };

    case types.UPDATE_QUIZ_LOGO_REQUEST:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo
      };
    case types.UPDATE_QUIZ_LOGO_COMPLETED:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        updatedLogo: action.updatedLogo
      };
    case types.UPDATE_QUIZ_LOGO_ERROR:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        logoUpdateError: action.logoUpdateError
      };

    default:
      return state;
  }
};
